import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve } from "@angular/router";
import { Observable } from "rxjs";
import { Shipment } from "../models/shipment";
import { ShipmentService } from "../services/shipment.service";

@Injectable()
export class ShipmentResolver implements Resolve<Shipment> {
  constructor(private service: ShipmentService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<Shipment> {
    const id = Number(route.paramMap.get("id"));
    if (id != 0) {
      return this.service.getShipmentById(+id);
    } else {
      return null;
    }
  }
}
